import React from 'react';
import { connect } from 'react-redux';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { CompositeSessionInfoSelectors, SessionServerSelectors, SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { extractMoveToTheWebEnabled } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { SpaceHeaderTestIds } from '~src/spacesPlatform/components/header/SpaceHeader';
import { SpaceHeaderStyles } from '~src/spacesPlatform/components/header/SpaceHeaderStyles';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { L10n } from '../../../../commonInfra/L10n/L10n';
import { ExtractEncryptionMode } from '../../../../commonInfra/utils/sites/SitePropertyTypes';
import { ConnectedDataSourceActionDropdown } from '../../../../datasource/components/DataSourceActionDropdown';
import { ExtractEncryptionState, IDataSourceDetailInfo } from '../../../../datasource/models/IDataSourceInfo';
import { IDatasourceActions } from '../../../../datasource/ServerApi/types/IDatasourceActions';
import { DatasourceContentType, FlowContentType, WorkbookContentType } from '../../../../spacesPlatform/models/ContentTypes';
import { ISpaceItemDetailInfo } from '../../../../spacesPlatform/models/ISpaceItemDetailInfo';
import { IWorkbookActions } from '../../../../workbook/ServerApi/types/IWorkbookActions';
import { ConnectedCancelExtractActionDropdown } from './CancelExtractActionDropdown';

export function ExtractTasksMetadata(props: ExtractTasksMetadataProps): JSX.Element {
    const { itemInfo, availableActions, isEncryptionEnabled, siteEARMode, isWebExtractionEnabled} = props;
    const showDataStatus: boolean = itemInfo.contentType === DatasourceContentType.name;
    const pendingEncryption = ((itemInfo.hasExtracts || itemInfo.hasEncryptableExtracts) &&  (itemInfo.extractEncryptionState ===  ExtractEncryptionState.pendingDecryption ||
                          itemInfo.extractEncryptionState ===  ExtractEncryptionState.pendingEncryption));
    const pendingCreation = itemInfo.extractCreationPending;
    const pending = pendingEncryption || pendingCreation;
    const lastRefreshedDate = itemInfo.lastRefreshedAt;
    const showExtractInfo = !pending && itemInfo.hasExtracts && lastRefreshedDate;
    let showEncryptionStatus = isEncryptionEnabled && itemInfo.hasEncryptableExtracts;
    if (showEncryptionStatus && itemInfo.contentType === FlowContentType.name && !FeatureFlags.maestroEarEnabled) {
      showEncryptionStatus = false;
    }
    const isExtractMoveToTheWebEnabled = itemInfo.contentType === WorkbookContentType.name ? isWebExtractionEnabled:
     extractMoveToTheWebEnabled(isWebExtractionEnabled, [itemInfo as IDataSourceDetailInfo]);
    return (
      <React.Fragment>
        {isExtractMoveToTheWebEnabled &&
          <span data-tb-test-id={SpaceHeaderTestIds.dataStatus} className={SpaceHeaderStyles.ExtractStatus}>
              {showDataStatus &&
                <div className={SpaceHeaderStyles.ExtractStatusLabel}>{Messages.extractStatusLabel()}</div>
              }
              { !pending &&
                  <ConnectedDataSourceActionDropdown itemInfo={itemInfo as ISpaceItemDetailInfo<'datasource'>} encryptionEnabled={isEncryptionEnabled}
                   siteEARMode={siteEARMode} disabled={!showDataStatus} availableActions = {availableActions}/>
                }
                { pending &&
                  <ConnectedCancelExtractActionDropdown itemInfo={itemInfo} hasExtracts={itemInfo.hasExtracts || itemInfo.hasEncryptableExtracts} encryptionEnabled={isEncryptionEnabled}
                  extractEncryptionState={extractEncryptionState(itemInfo)} extractCreationPending={itemInfo.extractCreationPending} disabled={false} siteEARMode={siteEARMode}
                  availableActions = {availableActions}/>
                }
                { showExtractInfo &&
                  <React.Fragment>
                    {!showEncryptionStatus &&
                      <span className={SpaceHeaderStyles.TextOnlyMetadataLabelWithLeftMargin}>
                        {Messages.datasourceHeaderLastRefreshed()}
                      </span>
                    }
                    <span className={SpaceHeaderStyles.MetadataInfo} data-tb-test-id={SpaceHeaderTestIds.lastRefreshed} title={Messages.datasourceHeaderLastRefreshed()}>
                      {L10n.localizedDateTime(lastRefreshedDate)}
                    </span>
                  </React.Fragment>
                }
            </span>
          }
      </React.Fragment>
    );
  }

export interface ExtractTaskMetadataOwnProps {
    itemInfo: ISpaceItemDetailInfo<'workbook' | 'datasource'>;
    availableActions: IWorkbookActions | IDatasourceActions;
  }

export interface ExtractTaskMetadataStateProps {
    isEncryptionEnabled: boolean;
    siteEARMode: ExtractEncryptionMode;
    isWebExtractionEnabled: boolean;
  }

export type ExtractTasksMetadataProps = ExtractTaskMetadataOwnProps & ExtractTaskMetadataStateProps;

const mapStateToProps: MapStateToProps<ExtractTaskMetadataStateProps> = (state: AppState) => {
    return {
      isEncryptionEnabled: SessionServerSelectors.extractEncryptionEnabledOmniSwitch(state),
      siteEARMode: SessionSiteSelectors.extractEncryptionMode(state),
      isWebExtractionEnabled: CompositeSessionInfoSelectors.isWebExtractionEnabled(state)
    };
  };

export const ConnectedExtractTasksMetadata = connect(mapStateToProps)(ExtractTasksMetadata);

function extractEncryptionState(itemInfo: ISpaceItemDetailInfo<'workbook' | 'datasource'>): ExtractEncryptionState {
    if (itemInfo.extractEncryptionState === ExtractEncryptionState.pendingDecryption || itemInfo.extractEncryptionState === ExtractEncryptionState.pendingEncryption)
    return itemInfo.extractEncryptionState;
    return ExtractEncryptionState.unencrypted;
  }
